import { XCircleIcon } from '@heroicons/react/outline'
import { Modal } from 'flowbite-react'
import React from 'react'

export const LogoutModal = ({ show, onClose, logout }) => {
  return (
    <React.Fragment>
      <Modal
        show={show}
        size="sm"
        popup={true}
        onClose={onClose}
      >
        <Modal.Body>

          <div className="py-5">
            <div>
              <div className="flex justify-between">
                <div />
                <XCircleIcon className="w-6 h-6 text-gray-500 cursor-pointer" onClick={onClose} />
              </div>
              <p className="text-center text-lg font-bold text-gray-700">
                Déconnection
              </p>
              <p className="py-5 text-sm text-gray-700">
                Vous êtes sur le point de vous déconnecter, Êtes-vous sûr?
              </p>
            </div>

            <div className="flex gap-2">
              <button
                onClick={logout}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary focus:outline-none"
              >
                Se déconnecter
              </button>
              <button
                onClick={onClose}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-700 focus:outline-none"
              >
                Annuler
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  )
}
